<template>
    <section id="programme" class="ProgramTimeline" v-if="normSections.length">
      <h2 class="PT__title" :class="isPhone ? 'merriweather-reg-18' : 'merriweather-reg-32'">Votre programme</h2>
  
      <div class="PT__grid">
        <div class="PT__col" v-for="(sec, sIdx) in normSections" :key="sec.id || sIdx">
          <div class="PT__head">
            <span class="raleway-bold-p16">{{ sec.title }}</span>
          </div>
  
          <ol class="PT__list">
            <li class="PT__item" v-for="(it, iIdx) in sec.items" :key="it.id || iIdx">
              <span class="PT__dot" aria-hidden="true"></span>
  
              <div class="PT__content">
                <div class="PT__time raleway-semi-p15"  v-if="it.time_text">{{ it.time_text }}</div>
                <div class="PT__label raleway-reg-p15" v-if="it.label">{{ it.label }}</div>
                <div class="PT__desc"  v-if="it.description">{{ it.description }}</div>
              </div>
            </li>
          </ol>
        </div>
      </div>
      <div class="PT__note">
        <span class="InfoBanner__icon" aria-hidden="true" v-html="iconSvg"></span>
      <p class="PT__noteText raleway-reg-p16">Pendant le séjour, les collaborateurs pourront également profiter des temps libres pour se détendre et recharger leurs batteries. Les 300 m2 d’extérieur et la proximité avec la réserve naturelle des Cheires et grottes de Volvic sont idéal pour des balades et des balades et des pauses inspirantes. À noter que le check out des chambres est prévu à 10h.</p>
    </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'ProgramTimeline',
    props: { sections: { type: Array, default: () => [] } },
    data() {
      return {
        isPhone: window.innerWidth < 768
      }
    },
    computed: {
      normSections () {
        const secs = Array.isArray(this.sections) ? this.sections : []
        return secs.slice()
          .sort((a,b) => (a.position ?? 0) - (b.position ?? 0))
          .map(s => ({
            id: s.id,
            title: s.title || '',
            items: (s.program_items || s.program_items_attributes || [])
              .slice()
              .sort((a,b) => (a.position ?? 0) - (b.position ?? 0))
              .map(it => ({
                id: it.id,
                label: (it.label || '').toString().trim(),       
                time_text: (it.time_text || '').toString().trim(),
                description: (it.description || '').toString().trim()
              }))
          }))
          .filter(s => s.title || s.items.length)
      },
      iconSvg () {
        return `
          <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="2" width="24" height="24" rx="6" fill="none" stroke="#4aa368" stroke-width="2"/>
            <circle cx="14" cy="19.5" r="1.6" fill="#4aa368"/>
            <rect x="13" y="7" width="2" height="9" rx="1" fill="#4aa368"/>
          </svg>
        `
    }
    }
  }
  </script>
  
  <style scoped>
  .ProgramTimeline{ padding:32px 16px 24px; background:#f6fbf8; }
  .PT__title{
    text-align:center; margin:0 0 18px; color:#0e0e0e;
  }
  
  .PT__grid{
    max-width:1200px; margin:0 auto; display:grid; gap:36px 56px;
    grid-template-columns:repeat(3,1fr);
  }
  @media (max-width:1100px){ .PT__grid{ grid-template-columns:1fr; gap:28px; } }
  
  .PT__head{
    background:#e9f3ee; color:#3B6152; text-align:center; font-weight:500;
    border-radius:28px; padding:22px 20px; letter-spacing:.2px;
    box-shadow:0 6px 0 #e6ece8 inset, 0 2px 0 rgba(0,0,0,.03);
    margin-bottom:16px;
  }
  
  .PT__list{
    list-style:none; margin:0; padding:0 0 0 96px; position:relative;
  }
  
  .PT__list::before{
    content:""; position:absolute; left:48px; top:0; bottom:0; width:2px;
    background:#2d5f49; opacity:.95; z-index:0;
  }
  
  .PT__item{ position:relative; padding:8px 0 26px; }
  
  .PT__dot{
    position:absolute; left:-47px; top:26px; width:14px; height:14px;
    border-radius:50%; background:#2d5f49; transform:translateX(-50%);
    z-index:1;
  }
  
  .PT__content{ line-height:1.6; }
  
  .PT__label{
    color:#000000; font-weight:400; letter-spacing:.2px;
    font-size:clamp(16px,2.1vw,15px); margin:0 0 2px;
  }
  
  .PT__time{
    color:#3B6152;
    margin:0 0 2px;
  }
  
  .PT__desc{
    color:#1a1a1a; font-size:clamp(14px,1.9vw,15px);
  }
  .PT__note{
  max-width:1200px; margin:28px auto 0;
  display:grid; grid-template-columns:32px 1fr; column-gap:14px;
  align-items:start; padding:0 4px 6px;
}
.PT__noteIcon{
  width:32px; height:32px; line-height:32px; text-align:center;
  font-weight:800; color:#2d5f49; border:3px solid #2d5f49;
  border-radius:6px; background:#f6fbf8;
}
.PT__noteText{
  margin:0; color:#0d0d0d; line-height:1.9;
}
.InfoBanner {
    font-family: 'Raleway';
  
    /* container */
    max-width: 1600px;           /* wide desktop */
    margin: 22px auto;
    padding: clamp(16px, 2.2vw, 28px) clamp(18px, 3vw, 36px);
    background: #eef6f2;         /* soft green */
    border: 1px solid #e2eee7;   /* subtle border */
    border-radius: 12px;
  
    /* layout */
    display: grid;
    grid-template-columns: 28px 1fr;
    column-gap: clamp(12px, 2vw, 18px);
    align-items: start;
  }
  
  /* smaller variant (second screenshot) */
  .InfoBanner.is-compact {
    padding: clamp(12px, 1.6vw, 20px) clamp(16px, 2.2vw, 24px);
    border-radius: 10px;
  }
  
  .InfoBanner__icon {
    line-height: 0;
    transform: translateY(2px);
  }
  
  .InfoBanner__text {
    color: #1f1f1f;
    margin: 0;
    line-height: 1.7;
    font-size: clamp(14px, 1.5vw, 16px); /* desktop matches screenshot typography */
  }
  @media (max-width: 768px) {
    .InfoBanner {
      grid-template-columns: 24px 1fr;
      row-gap: 6px;
    }
    .InfoBanner__text {
      font-size: clamp(14px, 4.2vw, 16px);
      line-height: 1.75;
    }
  }
  </style>
  